import React, { Component } from 'react'
import './UnauthenticatedHandler.css'

export class UnauthenticatedHandler extends Component {
    render() {
        return (
            <div className='authenticationErrorPageContainer' style={{height: window.innerHeight}}>
                <div className='authenticationErrorBackdrop' />
                <div className='authenticationErrorContainer'>
                    <div className='unauthenticated-popup-header'>You have been logged out</div>
                    <div className='popup-content'>
                        <p>You are no longer logged into this session and will have to refresh and re-login.</p>
                        <p>Your token has expired. Please log in again to refresh your token.</p>
                    </div>
                    <div className='options-footer'>
                        <input className='unauthenticated-button button-gap' type='button' value='OK' onClick={() => window.location.reload()}/>
                    </div>
                </div>
            </div>
        )
    }
}